import React from 'react';
import { Typography, Grid } from '@mui/material';

import ThreatChart from './ThreatChart';
import ThreatIndex from './ThreatIndex';
import UnAuthAccess from './UnAuthAccess';
import ThreatCategory from './ThreatCategory';

const Security = () => (
  <>
    <Typography component="h2" sx={{ color: '#1A2E42', fontSize: 34, lineHeight: '42px' }}>
      Security
    </Typography>
    <Grid container spacing={3} mt={1}>
      <Grid item xs={12} lg={5} data-testid="threat-unauth-access" sx={{ height: 292 }}>
        <UnAuthAccess />
      </Grid>
      <Grid item xs={12} lg={7} data-testid="threat-chart" sx={{ height: 292 }}>
        <ThreatChart />
      </Grid>
      <Grid item xs={12} data-testid="threat-index">
        <ThreatIndex />
      </Grid>
      <Grid item xs={12} data-testid="threat-by-category">
        <ThreatCategory />
      </Grid>
    </Grid>
  </>
);

export default Security;
